import QRCode from 'qrcodejs2'

export function loadImg (url) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => {
      resolve(img)
    }
    img.onerror = () => {
      reject(new Error('图片加载失败'))
    }
    img.src = url
  })
}

export function createQrCode (options) {
  return new Promise(resolve => {
    let el = options.el
    if (!el) {
      el = document.createElement('div');
      el.style.display = 'none';
      document.body.appendChild(el);
    }
    new QRCode(el, {
      text: options.text,
      width: options.width || 200,
      height: options.height || 200,
      colorDark: options.color || '#000000',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H
    })
    let qrCanvas = el.querySelector('canvas')
    el.remove()
    resolve(qrCanvas.toDataURL('image/png'));
  })
}

export async function createPoster (options) {
  options = {
    posterBgImg: '',
    posterWidth: 750,
    posterHeight: 1200,
    qrImgUrl: '', // 指定二维码图片
    qrText: '',
    qrWidth: 250,
    qrHeight: 250,
    qrLeft: 448,
    qrTop: 873,
    quality: 0.8,
    isAndroid: false,
    ...options
  }

  const qrCodeOption = {
    imgUrl: options.qrImgUrl,
    text: options.qrText,
    width: options.qrWidth,
    height: options.qrHeight,
    left: options.qrLeft,
    top: options.qrTop
  }

  const canvas = document.createElement('canvas');
  canvas.style.display = 'none';
  canvas.width = options.posterWidth;
  canvas.height = options.posterHeight;
  document.body.appendChild(canvas)
  const ctx = canvas.getContext('2d');

  const bgImg = await loadImg(options.posterBgImg)
  ctx.drawImage(bgImg, 0, 0, options.posterWidth, options.posterHeight)

  let qrImg = qrCodeOption.imgUrl || await createQrCode(qrCodeOption)
  qrImg = await loadImg(qrImg)
  ctx.drawImage(qrImg, qrCodeOption.left, qrCodeOption.top, qrCodeOption.width, qrCodeOption.height)

  let base64 = canvas.toDataURL('image/jpeg')
  canvas.remove()
  if (options.isAndroid) {
    return await base64ToUrl(base64)
  } else {
    return base64
  }
}

export async function base64ToUrl (base64) {
  const arr = base64.split(',')
  const imgType = arr[0].match(/:(.*?);/)[1]
  const bytes = window.atob(arr[1])

  const ab = new ArrayBuffer(bytes.length)
  const ia = new Uint8Array(ab)
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i)
  }
  const blob = new Blob([ab], {type: imgType})
  const fd = new FormData()
  fd.append('file', blob, 'image.png')
  fd.append('key', '2020_activity_yh_' + new Date().getTime())   //自定义图片名
  let res = await fetch('//restapi.xuanwonainiu.com/agent/image/save', {
    method: 'post',
    body: fd,
  })
  if (res.status === 200) {
    res = await res.json();
    if (res.status === 1 && res.data && res.data.url) {
      return res.data.url
    }
  }
  return res;
}


